import { motion } from "framer-motion";

const KineticLines = ({ lines, delay = 0, testid }) => (
    <span data-testid={testid}>
        {lines.map((line, i) => (
            <span key={i} className="block overflow-hidden pb-[0.1em] -mb-[0.1em]">
                <motion.span
                    className="block will-change-transform"
                    initial={{ y: "112%" }}
                    animate={{ y: "0%" }}
                    transition={{ duration: 0.95, delay: delay + i * 0.14, ease: [0.22, 1, 0.36, 1] }}
                >
                    {line}
                </motion.span>
            </span>
        ))}
    </span>
);

export default KineticLines;
